"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ampm = exports.minute = exports.hour24 = exports.hour = void 0;
var hour = [{
  title: '01',
  value: 1
}, {
  title: '02',
  value: 2
}, {
  title: '03',
  value: 3
}, {
  title: '04',
  value: 4
}, {
  title: '05',
  value: 5
}, {
  title: '06',
  value: 6
}, {
  title: '07',
  value: 7
}, {
  title: '08',
  value: 8
}, {
  title: '09',
  value: 9
}, {
  title: '10',
  value: 10
}, {
  title: '11',
  value: 11
}, {
  title: '12',
  value: 0
}];
exports.hour = hour;
var hour24 = [{
  title: '00',
  value: 0
}, {
  title: '01',
  value: 1
}, {
  title: '02',
  value: 2
}, {
  title: '03',
  value: 3
}, {
  title: '04',
  value: 4
}, {
  title: '05',
  value: 5
}, {
  title: '06',
  value: 6
}, {
  title: '07',
  value: 7
}, {
  title: '08',
  value: 8
}, {
  title: '09',
  value: 9
}, {
  title: '10',
  value: 10
}, {
  title: '11',
  value: 11
}, {
  title: '12',
  value: 12
}, {
  title: '13',
  value: 13
}, {
  title: '14',
  value: 14
}, {
  title: '15',
  value: 15
}, {
  title: '16',
  value: 16
}, {
  title: '17',
  value: 17
}, {
  title: '18',
  value: 18
}, {
  title: '19',
  value: 19
}, {
  title: '20',
  value: 20
}, {
  title: '21',
  value: 21
}, {
  title: '22',
  value: 22
}, {
  title: '23',
  value: 23
}];
exports.hour24 = hour24;
var minute = [{
  title: '0',
  value: 0
}, {
  title: '1',
  value: 1
}, {
  title: '2',
  value: 2
}, {
  title: '3',
  value: 3
}, {
  title: '4',
  value: 4
}, {
  title: '5',
  value: 5
}, {
  title: '6',
  value: 6
}, {
  title: '7',
  value: 7
}, {
  title: '8',
  value: 8
}, {
  title: '9',
  value: 9
}, {
  title: '10',
  value: 10
}, {
  title: '11',
  value: 11
}, {
  title: '12',
  value: 12
}, {
  title: '13',
  value: 13
}, {
  title: '14',
  value: 14
}, {
  title: '15',
  value: 15
}, {
  title: '16',
  value: 16
}, {
  title: '17',
  value: 17
}, {
  title: '18',
  value: 18
}, {
  title: '19',
  value: 19
}, {
  title: '20',
  value: 20
}, {
  title: '21',
  value: 21
}, {
  title: '22',
  value: 22
}, {
  title: '23',
  value: 23
}, {
  title: '24',
  value: 24
}, {
  title: '25',
  value: 25
}, {
  title: '26',
  value: 26
}, {
  title: '27',
  value: 27
}, {
  title: '28',
  value: 28
}, {
  title: '29',
  value: 29
}, {
  title: '30',
  value: 30
}, {
  title: '31',
  value: 31
}, {
  title: '32',
  value: 32
}, {
  title: '33',
  value: 33
}, {
  title: '34',
  value: 34
}, {
  title: '35',
  value: 35
}, {
  title: '36',
  value: 36
}, {
  title: '37',
  value: 37
}, {
  title: '38',
  value: 38
}, {
  title: '39',
  value: 39
}, {
  title: '40',
  value: 40
}, {
  title: '41',
  value: 41
}, {
  title: '42',
  value: 42
}, {
  title: '43',
  value: 43
}, {
  title: '44',
  value: 44
}, {
  title: '45',
  value: 45
}, {
  title: '46',
  value: 46
}, {
  title: '47',
  value: 47
}, {
  title: '48',
  value: 48
}, {
  title: '49',
  value: 49
}, {
  title: '50',
  value: 50
}, {
  title: '51',
  value: 51
}, {
  title: '52',
  value: 52
}, {
  title: '53',
  value: 53
}, {
  title: '54',
  value: 54
}, {
  title: '55',
  value: 55
}, {
  title: '56',
  value: 56
}, {
  title: '57',
  value: 57
}, {
  title: '58',
  value: 58
}, {
  title: '59',
  value: 59
}];
exports.minute = minute;
var ampm = [{
  title: 'AM',
  value: 'am'
}, {
  title: 'PM',
  value: 'pm'
}];
exports.ampm = ampm;